<template>
  <a
    :class="['anchor-link', {'sb-disabled': disabled}]"
    data-sb-regression="sb-anchor"
    v-bind="$attrs"
    v-on="$attrs"
  >
    <!--
      @slot text, components, or HtmlElements as children of the component
     -->
    <slot />
  </a>
</template>

<script>
/**
 * Anchor element used for inputs
 */
export default {
  name: 'SbAnchor',
  props: {
    /**
     * Disables the anchor
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@src/components/Anchor/style/sb-anchor.scss';
</style>
